export default "__VITE_ASSET__DLrgcYpx__"